require('./angular-sanitize');
module.exports = 'ngSanitize';



//////////////////
// WEBPACK FOOTER
// ./~/angular-sanitize/index.js
// module id = 502
// module chunks = 6